import ReactGA from 'react-ga4';
import { getConfig } from '../utils/config';

const GA_ID = getConfig().gaMeasurementId;
export const GAService = {
  init: () => {
    if (import.meta.env.DEV) {
      console.log('[GA] init skipped in dev mode!');
      return;
    }
    console.log('[GA] init service');
    ReactGA.initialize(GA_ID);
  },
};
